var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "pcAccessPopupModal", "data-backdrop": "static" },
    },
    [
      _c("div", { staticClass: "modal-dialog" }, [
        _c(
          "div",
          { staticClass: "modal-content" },
          [
            _vm._m(0),
            _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("img", {
        staticClass: "close-icon",
        attrs: {
          "data-dismiss": "modal",
          src: "/static/images/icons/close_icon.svg",
          alt: "close-icon",
        },
      }),
      _c("div", { staticClass: "card text-center" }, [
        _c("img", {
          staticClass: "info-logo",
          attrs: {
            src: require("../../../public/static/images/icons/info_icon_active.svg"),
            alt: "checkbox-icon",
          },
        }),
        _c("div", { staticClass: "card-title" }, [
          _c("p", { staticClass: "verification-text" }, [
            _vm._v(" Your trial subscription has expired "),
          ]),
        ]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-lg-12 card-text" }, [
            _c("p", { staticClass: "success-message" }, [
              _vm._v(" Please visit our "),
              _c("a", { attrs: { href: "/layout/market-place" } }, [
                _vm._v("marketplace"),
              ]),
              _vm._v(
                " to purchase a subscription to the Product Classification Tool. Please note that the subscription to any other RAMS Premium Services will include complimentary access to the Product Classification Tool. "
              ),
            ]),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-12 ok-btn" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-block emergo-green-button",
              attrs: { "data-dismiss": "modal" },
            },
            [_vm._v(" OK ")]
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }